import { render, staticRenderFns } from "./PromocionSaludSeVital.vue?vue&type=template&id=1f0f6e96&scoped=true&"
var script = {}
import style0 from "./PromocionSaludSeVital.vue?vue&type=style&index=0&id=1f0f6e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f6e96",
  null
  
)

export default component.exports